import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly defaultDurationMs = 3000;

  open(message: string, panelClass?: string, config?: MatSnackBarConfig): void {
    const merged: MatSnackBarConfig = {
      duration: this.defaultDurationMs,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: panelClass ? [panelClass] : undefined,
      ...config,
    };
    this.snackBar.open(message, 'OK', merged);
  }

  success(message: string, config?: MatSnackBarConfig): void {
    this.open(message, 'snackbar-success', config);
  }

  error(message: string, config?: MatSnackBarConfig): void {
    this.open(message, 'snackbar-error', config);
  }

  /**
   * Success message with an undo action (e.g. after deactivating a record). `onUndo` runs only
   * when the user presses the action before the snackbar closes.
   */
  withUndo(message: string, undoLabel: string, onUndo: () => void): void {
    this.snackBar
      .open(message, undoLabel, {
        duration: 6000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-success'],
      })
      .onAction()
      .subscribe(() => onUndo());
  }
}
